<template>
  <v-container>
    <v-progress-linear
      v-if="loading"
      indeterminate
      class="ma-2"
    ></v-progress-linear>
    <v-container v-else-if="!estimate || !price">
      <v-alert class="mt-3" type="error" outlined dense>
        Невозможно загрузить смету.
      </v-alert>
    </v-container>
    <single-estimate 
      v-else 
      :key="componentId"
      :estimate="estimate"
      :price="price"
      @save="save($event)"
      :hideSiteBlock="isPartner"
    ></single-estimate>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import SingleEstimate from '../components/estimates/SingleEstimate';

export default {
  props: {
    id: String
  },

  components: {
    SingleEstimate
  },

  data() {
    return {
      estimate: null,
      price: null,
      componentId: this.getTempId(),
      loading: false
    }
  },

  async created() {
    document.title = 'Карточка сметы';
    if (this.id) {
      this.loading = true;
      try {
        this.estimate = await this.$store.dispatch('estimates/loadSingle', this.id);
        if (this.estimate.ownerUser) {
          await this.$store.dispatch('prices/loadList');
          this.price = this.$store.state.prices.curPrice;
        } else {
          this.price = await this.$store.dispatch('prices/loadCustomerPrice', this.estimate.ownerCustomer._id);
        }
        this.componentId = this.getTempId();
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
  
      }
      
    } 
  },

  methods: {
    save(data) {
      this.$store.dispatch('estimates/update', {...data, _id: this.id})
        .then(res => {
          this.$store.dispatch('showMessage', res.message);
        });
    }
  },

  watch: {
    id() {
      /*this.componentId = getTempId();
      if (this.id) {
        this.$store.dispatch('estimates/loadSingle', this.id).then(res => {
          this.estimate = res;
          this.componentId = getTempId()
        });
        this.$store.dispatch('prices/loadList');
      } else {
        this.$store.dispatch('estimates/loadList');
      }*/
    }
  },

  computed: {
    ...mapGetters('users', ['isPartner']),
    ...mapGetters('prices', ['loadingList'])
  }
}
</script>